import { t } from '../../../../services/i18nService';

const gapMatchInteractionSelector = {
    /**
 * Extracts visible text from a paragraph element within a Gap Match Interaction.
 * It iterates through child nodes and handles text nodes, SPANs (gaps), and tokens in gaps.
 *
 * @param {HTMLElement} paragraphElement The paragraph DOM element to process.
 * @returns {string} The full text of the paragraph including gap contents.
 */
    getParagraphText: (paragraphElement) => {
        if (!paragraphElement) return '';

        const parts = Array.from(paragraphElement.childNodes).map((node) => {
            if (node.nodeType === Node.TEXT_NODE) {
                return (node.textContent || '').trim();
            }
            if (node.nodeName === 'SPAN') {
            // Inside span there is a drop zone div and possibly a token element
                const tokenInGapEl = node.querySelector('.gapText');
                if (tokenInGapEl && tokenInGapEl.textContent) {
                    return tokenInGapEl.textContent.trim();
                }
                const gapId = node.querySelector('div[id^="scorableItem"]')?.getAttribute('data-identifier');
                return (gapId || '').trim();
            }
            return '';
        });

        return parts.filter(Boolean).join(' ');
    },

    /**
 * Returns the localized announcement message for a token moved to a gap.
 *
 * @param {string} tokenData The text content of the token.
 * @param {string} gapIdentifier The identifier of the target gap.
 * @returns {string} Localized message.
 */
    getTokenGapAnnouncement: (tokenData, gapIdentifier) => {
        return t('generic.ariaLive.tokenGapMessage', { tokenData, gapIdentifier });
    },

    /**
     * Returns the localized announcement message for the full paragraph text.
     *
     * @param {string} paragraphText The extracted paragraph text.
     * @returns {string} Localized message.
     */
    getFullParagraphAnnouncement: (paragraphText) => {
        return t('generic.ariaLive.fullParagraph', { liveMessage: paragraphText });
    },

};

export default gapMatchInteractionSelector;
